import {MatStepperIntl} from '@angular/material/stepper';

export function getPolishStepperIntl() {
  const stepperIntl = new MatStepperIntl();
  stepperIntl.optionalLabel = 'Opcjonalnie';
  return stepperIntl;
}
